import React from 'react'
import { Button } from '@fs/zion-ui'
import { ArrowCaret } from '@fs/zion-icon'

import transl from './BackToRecordsHomeButton.transl'

export default function BackToRecordsHomeButton() {
  return (
    <Button Icon={ArrowCaret} keyline="left" to="/home" iconDirection="backward">
      {transl.buttonText()}
    </Button>
  )
}
